module.exports = __webpack_public_path__ + "static/img/mEwm1.bcf5531.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/mEwm1.png
// module id = TXTG
// module chunks = 0